// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"87d81925","552":"e41659e2","784":"fe4d3b8a","817":"5e023ea5","959":"feef69a4","962":"ffb5de9f"}[chunkId] + ".chunk.js";
};